<sbnb-signup-wizard-template>
  <ng-container left-side>
    <h1 class="text-2xl md:text-3xl mb-8">Create your password</h1>

    <form [formGroup]="form">
      <div class="flex flex-col md:flex-row gap-0 md:gap-4">
        <div class="flex-1">
          <label class="text-sm font-bold block text-night" for="password">Password</label>
          <mat-form-field class="w-full">
            <input
              matInput
              autocomplete="off"
              type="password"
              name="password"
              formControlName="password"
              placeholder="Min 8 characters"
              (focus)="showPasswordHints = true"
              (blur)="showPasswordHints = false" />
            <mat-error *ngIf="form.controls.password.hasError('required')">
              Password {{ 'CORE.IS_REQUIRED' | transloco }}
            </mat-error>
          </mat-form-field>

          <div *ngIf="showPasswordHints" class="bg-white rounded-2xl shadow-2xl p-5 absolute z-10 -mt-4">
            <div class="grid gap-2">
              <div *ngFor="let validationMessage of validationMessages">
                <div class="flex items-center gap-1">
                  <sbnb-icon
                    [size]="14"
                    [class]="
                      !form.controls.password.hasError(validationMessage.key)
                        ? 'text-grass-darker'
                        : 'text-smoke-darker'
                    "
                    [icon]="
                      !form.controls.password.hasError(validationMessage.key) ? 'check' : 'not-allowed'
                    "></sbnb-icon>
                  <p
                    class="m-0 text-sm"
                    [class]="
                      !form.controls.password.hasError(validationMessage.key) ? 'text-grass-darker' : 'text-night'
                    ">
                    {{ validationMessage.message }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="flex-1">
          <label class="text-sm font-bold block text-night" for="confirm">Password check</label>
          <mat-form-field class="w-full">
            <input
              matInput
              autocomplete="off"
              type="password"
              name="confirm"
              formControlName="confirm"
              placeholder="Repeat password" />
            <mat-error *ngIf="form.controls.password.valid && form.controls.confirm.hasError('mismatch')">
              The passwords don’t match.
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <sbnb-button
        class="block mt-8"
        [fullWidth]="true"
        [disabled]="form.invalid"
        [loading]="loading"
        (clicked)="onContinue()">
        Continue
      </sbnb-button>
    </form>
  </ng-container>

  <img right-side src="/assets/images/signup/password.svg" />
</sbnb-signup-wizard-template>
